/** =========================================================
 * Module: input-file.directive.js
 * File input
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .directive('inputFile', inputFile);

  inputFile.$inject = ['$rootScope', '$api', '$translate'];

  function inputFile($rootScope, $api, $translate) {
    var directive = {
      require: '?ngModel',
      restrict: 'E',
      link: link,
      template: '<div class="input-group"><span class="input-group-addon icon-holder fw" style="background-color: #fff;"></span><input class="file-input" accept="{{onlyImages ? \'image/*\' : \'*\' }}" type="file" style="display: none;"><span class="input-group-btn"><button class="btn btn-default btn-block" type="button" ng-click="triggerInput()">{{ buttonLabel | translate }}</button></span><span class="input-group-btn file-input-clear" ng-if="showRemove"><button class="btn btn-danger btn-block" type="button" ng-click="clear()"><i class="fa fa-trash-o"></i></button></span><span class="input-group-btn" ng-if="download"><button class="btn btn-default btn-block" type="button" ng-click="downloadFile()"><i class="fa fa-download"></i></button></span></div>',
      scope: {
        download: '@?',
        onlyImages: '@?',
        originalName: '@?',
        preventImage: '@?',
        sizeLimit: '@?'
      }
    };

    return directive;

    function link($scope, elem, attrs, ngModel) {
      function insertLoader() {
        elem.find('.icon-holder').html('<img style="height: 21px;" src="app/img/loader.gif" alt="Loading...">');
        $scope.buttonLabel = $translate.instant('Please wait');
        $scope.showRemove = false;
      }

      function insertNoFile() {
        elem.find('.icon-holder').html('<span class="text-muted">' + $translate.instant('No file') + '</span>');
        $scope.buttonLabel = $translate.instant('Select');
        $scope.showRemove = false;
      }

      function insertFile(file) {
        var output = '';
        var extension = file.slice(file.lastIndexOf('.') + 1);

        if (['jpg', 'jpeg', 'png', 'gif'].indexOf(extension) !== -1 && !$scope.preventImage) {
          output = '<a href="' + $rootScope.config.server_url + '/uploads/' + file + '" data-fancybox><img style="height: 21px;" src="' + $rootScope.config.server_url + '/uploads/thumbs/' + file + '" alt="Upload"></a>';
        } else {
          output = '<a href="' + $rootScope.config.server_url + '/uploads/' + file + '" target="_blank"><em class="icon-doc"></em> ' + (file.length > 20 ? file.slice(0, 17) + '...' : file) + '</a>';
        }

        elem.find('.icon-holder').html(output);
        $scope.buttonLabel = $translate.instant('Change');
        $scope.showRemove = true;
      }

      $scope.downloadFile = function () {
        var url = $rootScope.config.server_url + '/uploads/' + ngModel.$viewValue;
        var fileName = ngModel.$viewValue;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
          var urlCreator = window.URL || window.webkitURL;
          var imageUrl = urlCreator.createObjectURL(this.response);
          var tag = document.createElement('a');
          tag.href = imageUrl;
          tag.download = fileName;
          document.body.appendChild(tag);
          tag.click();
          document.body.removeChild(tag);
        };
        xhr.send();
      };

      $scope.triggerInput = function () {
        $(elem.find('input')).click();
      };

      $scope.clear = function () {
        ngModel.$setViewValue(null);
        ngModel.$render();

        insertNoFile();
      };

      elem.find('.file-input').on('change', function (evt) {
        try {
          var file = evt.currentTarget.files[0];

          if (file && file.size) {
            var allowedSize = (parseInt($scope.sizeLimit, 10) * 1024 * 1024);

            if ($scope.sizeLimit && allowedSize <= file.size) {
              // eslint-disable-next-line
              alert('Too big! limit: ' + $scope.sizeLimit + 'mb');
              insertNoFile();

              return;
            }

            insertLoader();

            var request = {
              file: file
            };

            if (typeof $scope.preventImage !== 'undefined') {
              request.preventImage = $scope.preventImage;
            }

            if (typeof $scope.originalName !== 'undefined') {
              request.originalName = $scope.originalName;
            }

            $api.uploadFile(request).then(function (response) {
              if (response.status) {
                var receivedFile = response.data;

                insertFile(receivedFile);
                ngModel.$setViewValue(receivedFile);
                ngModel.$render();
              } else {
                insertNoFile();
              }
            });
          }
        } catch (error) {
          insertNoFile();

          Raven.captureException(error);
        }
      });

      ngModel.$render = function () {
        var file = ngModel.$viewValue;

        if (file) {
          insertFile(file);
        } else {
          insertNoFile();
        }
      };
    }
  }
})();
